import { applyMiddleware, compose, createStore } from 'redux';
import LogRocket from 'logrocket';
import ReduxThunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { persistStore } from 'redux-persist';
import rootReducer from 'redux/reducers/rootReducer.js';
import * as customMiddleware from '../../middleware';

export const history = createBrowserHistory();

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: true,
        traceLimit: 25,
      })
    : compose;

function configureStore(preloadedState) {
  return createStore(preloadedState, composeEnhancers(applyMiddleware(routerMiddleware(history), ReduxThunk, ...Object.values(customMiddleware), LogRocket.reduxMiddleware())));
}

const store = configureStore(rootReducer(history));
const persistor = persistStore(store);

export { store, persistor };
